import type { PanelType } from '../../../model/panels/types.tsx';
import type { PanelState as PanelsType } from '../../reducers/ui/panels/types.tsx';

export const TOGGLE_PANEL = 'state.actions.panels.TOGGLE_PANEL' as const;

export type TogglePanelAction = {
	type: typeof TOGGLE_PANEL;
	payload: {
		panel: PanelType;
	};
};

export const togglePanel = (panel: PanelType): TogglePanelAction => ({
	type: TOGGLE_PANEL,
	payload: {
		panel,
	},
});

export const CLOSE_INSIGHTS_PANEL = 'state.actions.panels.CLOSE_INSIGHTS_PANEL' as const;

export type CloseInsightsPanelAction = {
	type: typeof CLOSE_INSIGHTS_PANEL;
	payload: {
		shouldUpdateLocation?: boolean;
	};
};

export const closeInsightsPanel = (shouldUpdateLocation = true): CloseInsightsPanelAction => ({
	type: CLOSE_INSIGHTS_PANEL,
	payload: {
		shouldUpdateLocation,
	},
});

export const CLOSE_VIEW_SETTINGS_PANEL = 'state.actions.panels.CLOSE_VIEW_SETTINGS_PANEL' as const;

export type CloseViewSettingsPanelAction = {
	type: typeof CLOSE_VIEW_SETTINGS_PANEL;
};

export const closeViewSettingsPanel = (): CloseViewSettingsPanelAction => ({
	type: CLOSE_VIEW_SETTINGS_PANEL,
});

/**
 * @deprecated Create new action for routing change or app load. Best practices "actions as events" - https://redux.js.org/style-guide/#model-actions-as-events-not-setters
 */
export const SET_ALL_PANELS = 'state.actions.panels.SET_ALL_PANELS' as const;

/**
 * @deprecated Create new action for routing change or app load. Best practices "actions as events" - https://redux.js.org/style-guide/#model-actions-as-events-not-setters
 */
export type SetAllPanelsAction = {
	type: typeof SET_ALL_PANELS;
};

/**
 * @deprecated Create new action for routing change or app load. Best practices "actions as events" - https://redux.js.org/style-guide/#model-actions-as-events-not-setters
 */
export const setAllPanels = (): SetAllPanelsAction => ({
	type: SET_ALL_PANELS,
});

export const SET_ALL_PANELS_SUCCESS = 'state.actions.panels.SET_ALL_PANELS_SUCCESS' as const;

export type SetAllPanelsActionSuccess = {
	type: typeof SET_ALL_PANELS_SUCCESS;
	payload: {
		panels: PanelsType;
	};
};

export const setAllPanelsSuccess = (panels: PanelsType): SetAllPanelsActionSuccess => ({
	type: SET_ALL_PANELS_SUCCESS,
	payload: {
		panels,
	},
});

export type Action =
	| TogglePanelAction
	| SetAllPanelsAction
	| CloseInsightsPanelAction
	| SetAllPanelsActionSuccess
	| CloseViewSettingsPanelAction;
